import { Link } from '@tanstack/react-router';

import { LogOut } from 'lucide-react';

import { cn, ThemeToggle } from '@src/components/ui';
import { useSidebar } from '@src/context/hooks';

import { roleLabel } from './roles';


function initials(user) {
  const letters = [user?.first_name, user?.last_name]
    .map((part) => (part || '').charAt(0))
    .join('');
  return (letters || (user?.email || '?').charAt(0)).toUpperCase();
}


/** User footer row per the .pen Sidebar component (avatar initials + name +
 * role), plus a sign-out affordance the design leaves implicit. */
function SidebarUser({ user, membership }) {
  const { isCollapsed } = useSidebar();

  if (!user) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex h-11 items-center gap-2 rounded-lg bg-surface-2 px-2',
        isCollapsed && 'justify-center bg-transparent px-0',
      )}
    >
      <span
        className={cn(
          'bg-brand-gradient grid size-7 shrink-0 place-items-center rounded-full',
          'text-xs font-bold text-white',
        )}
      >
        {initials(user)}
      </span>

      {!isCollapsed
        ? (
          <>
            <span className="flex min-w-0 flex-1 flex-col">
              <span className="truncate text-table font-semibold text-ink">
                {`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email}
              </span>

              <span className="text-[10.5px] text-ink-subtle">{roleLabel(membership?.role)}</span>
            </span>

            <ThemeToggle className="size-7 rounded-md text-ink-subtle hover:bg-surface-1 hover:text-ink" />

            <Link
              title="Sign out"
              aria-label="Sign out"
              className="rounded-md p-1.5 text-ink-subtle hover:bg-surface-1 hover:text-ink"
              to="/auth/logout"
            >
              <LogOut className="size-4" />
            </Link>
          </>
        )
        : null}
    </div>
  );
}

SidebarUser.displayName = 'SidebarUser';
export default SidebarUser;
